

<template>



  <div class="boxDetaiJc"   ref="detail">
<!--    <i class="el-icon-error" @click="close"  style="font-size: 30px;color:red;position: absolute;right:0;top:0;"></i>-->
    <div class="detaiBox" style="width: 100%;height:100%;overflow: auto;">
<!--      <div class="buttonBox" style="justify-content: flex-end;font-size: 30px;box-sizing: border-box">-->
<!--        <span>教程详情</span>-->
<!--      </div>-->
      <div class="name" style="text-align: left;min-height: 80px;">
        <div class="title">标题</div>
        <span class="textCon">{{rowMy&&rowMy['name']?rowMy['name']:''}}</span>
      </div>
      <div class="name" style="text-align: left;min-height: 150px;">
        <div class="title">教程描述</div>
        <span class="textCon" v-html="rowMy['description']"></span>
      </div>

    </div>
  </div>

</template>
<script>
import {getUserInfo,getGameDetail} from "@/api/qt/common"
export default {
  props:['row'],
  data(){
    return {
      baseUrl:"",
      userInfo:{},
      gameInfo:{},
      rowMy:{}
      // row:{}
    };
  },
  created() {
    this.baseUrl=this.$baseUrl;
    console.log(this.row,"传过来的")
    this.getUserInfoMy();
    this.getMyInfo();
  },
  mounted() {
    // this.getGameInfo();
  },
  computed:{
    isVip(){
      return new Date(this.userInfo.end_time*1000).getTime()>new Date().getTime();
    }
  },
  methods:{
    getMyInfo(){
      getUserInfo(localStorage.getItem("token")).then((res)=>{
        console.log(res.data,"获取用户信息")
        let userInfo = res.data.data;
        this.userInfo = userInfo;
      })
    },
    getGameInfo(){
      console.log(this.row,'1111');
      getGameDetail(this.row.id).then((res)=>{
        // let data=res.data;
        // let reg=/"data":([\d\D]+)}/;
        // let re=data.match(reg)
        // let data1=JSON.parse(re[1])
        //
        // data1.description=data1.description.replaceAll('`',"")
        // this.row=data1
        this.rowMy=res.data.data;
        this.rowMy.description=this.rowMy.description.replaceAll('`',"").replaceAll('yxsjz.cn',"bajiaoyouxi.cn")
      })
    },
    getUserInfoMy(){
      this.getGameInfo();
      // getUserInfo(localStorage.getItem('token')).then((res)=>{
      //   this.userInfo=res.data.data
      //   this.getGameInfo();
      //   // if(this.userInfo.vip>0){
      //   //   console.log("是vip")
      //   //   this.getGameInfo();
      //   // }else{
      //   //   console.log("不是vip")
      //   //
      //   //   this.gameInfo=this.row;
      //   // }
      // })
    },
    close(){
      console.log("close")
      this.$emit("setGameInfoShow",false)
    }
  }
}
</script>
<style scoped>
.boxDetaiJc{
  width:80%;
  margin: auto;
  margin-left:10%;

  background-color: #fff;
  padding: 20px;
  box-sizing: border-box;


}
.boxDetai::-webkit-scrollbar-thumb{
  width: 5px;
}
.box
.title{
  background-color: #2c3e50;
  line-height: 30px;
  font-size: 16px;
  text-align: left;
  padding-left: 3px;
  color:#fff;
  box-sizing: border-box;
}
.name{
  margin-top: 18px;
}
.textCon{
  padding-left: 15px;
  box-sizing: border-box;
  line-height: 20px;
  margin-top: 15px;
  display: block;
  text-align: center;
}
/* 针对 WebKit 引擎的浏览器（如 Chrome 和 Safari） */
::-webkit-scrollbar {
  display: none;
  width: 10px; /* 滚动条的宽度 */
}

/* 滚动条轨道 */
::-webkit-scrollbar-track {
  background: white; /* 滚动条背景颜色 */
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  background: #eee; /* 滑块颜色 */
  border-radius: 10px; /* 可以添加圆角 */
}

/* 滚动条滑块在点击拖动时（可选）*/
::-webkit-scrollbar-thumb:active {
  background: darkgreen; /* 滑块在拖动时的颜色 */
}

/* 如果需要为滚动条添加过渡效果（可选）*/
::-webkit-scrollbar-thumb {
  transition: background 0.3s ease;
}

/* 应用滚动条样式的元素 */
.scrollable-element {
  /* 设置 overflow 属性以显示滚动条 */
  overflow-y: auto; /* 或者 overflow-x: auto; 如果你需要水平滚动条 */
  height: 200px; /* 或者 width: 200px; 取决于你的需求 */
}
</style>